import React from "react";
import Popup from "reactjs-popup";
import { BolFieldValue } from "../../../../app/data/pickup-requests/bolModels";
import { shouldShowAiBadge, shouldShowMissingBadge } from "../utils/bolFieldBadges";

export interface BolFieldWithAiProps {
  label: string;
  field?: BolFieldValue | null;
  required?: boolean;
  showAiBadge?: boolean;
  readOnly?: boolean;
  children: React.ReactNode;
}

const MissingBadge: React.FC<{ aiMessage?: string | null }> = ({ aiMessage }) => {
  const badge = (
    <span className="xgs-bol-field__badge xgs-bol-field__badge--missing xgs-bol-field__badge--missing-tooltip">
      Missing
    </span>
  );
  if (!aiMessage) return badge;
  return (
    <Popup
      trigger={badge}
      position="top center"
      on={["hover"]}
      offsetY={5}
      arrowStyle={{ borderWidth: "0px" }}
      contentStyle={{
        borderRadius: "4px",
        boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.20)",
        borderWidth: "0px",
        padding: "8px 10px",
        fontSize: "12px",
        lineHeight: "1.4",
        maxWidth: "280px",
      }}
    >
      <div className="xgs-bol-field__missing-tooltip">{aiMessage}</div>
    </Popup>
  );
};

const BolFieldWithAi: React.FC<BolFieldWithAiProps> = ({
  label,
  field,
  required,
  showAiBadge = true,
  readOnly,
  children,
}) => (
  <div className="xgs-bol-field xgs-bol-field--figma xgs-bol-field--compact">
    <div className="xgs-bol-field__label-row">
      <span className="xgs-bol-field__label xgs-bol-field__label--figma">
        {label}
        {required && <span className="xgs-bol-field__required"> *</span>}
      </span>
      {shouldShowAiBadge(field, showAiBadge) && (
        <span className="xgs-bol-field__badge xgs-bol-field__badge--ai">AI</span>
      )}
      {shouldShowMissingBadge(field, readOnly) && (
        <MissingBadge aiMessage={field?.aiMessage} />
      )}
    </div>
    {children}
  </div>
);

export default BolFieldWithAi;
